"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIsPostalCodeValid = exports.isValidEmail = exports.hasAlphabeticCharacter = void 0;
var __1 = require("../..");
var hasAlphabeticCharacter = function (value) {
    return !value ? true : __1.HAS_ALPHA_CHARACTER_REGEX.test(value || '');
};
exports.hasAlphabeticCharacter = hasAlphabeticCharacter;
var isValidEmail = function (email) { return __1.EMAIL_VALIDATOR_REGEX.test(email); };
exports.isValidEmail = isValidEmail;
var getIsPostalCodeValid = function (postalCode) {
    if (!postalCode) {
        return false;
    }
    return __1.POSTAL_CODE_REGEX.test(postalCode);
};
exports.getIsPostalCodeValid = getIsPostalCodeValid;
